﻿import assets from 'assets'
import util from 'utils'
import storage from 'storage'
import cookie from 'cookie'
import sessionCookie from 'session-cookie'
import browser from 'browser'
import actions from 'actions'
import io from 'socket.io-client'
import jQuery from 'jquery'
import config from './config/config.js'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import 'jquery-ui/widget'
import 'jquery-ui/widgets/draggable'
import 'jquery-ui-touch-punch'
import '../src/config/config'

const uuidV4 = require('uuid/v4')

jQuery.widget('vaf.chatwidget', {
  // Element to use when a widget instance is constructed without providing an element
  defaultElement: '<aside>',

  // Default widget options
  options: Object.assign({
    assistant: {
      name: `${global.gConfig.app_name}`,
      avatar: assets.images['avatar']
    },
    constants: {
      MAXLENGTH_INPUT: global.gConfig.maxlength_input,
      ORIGIN_NAME:  global.gConfig.origin_name
    },
    icons: assets.icons,
    server: {
      protocol: `${global.gConfig.protocol}`,
      host: `${global.gConfig.host_bff}`
    }
  }, actions),

  // Life cycle methods
  _create: function () {
    // Render templates and initialize element
    this.element.html(util.render('widget', {
      assistant: this.options.assistant,
      icons: this.options.icons,
      constants: this.options.constants
    }))
    // Start hidden
    this._hide(this.element)

    // Select DOM elements
    this._header    = this.element.find('.wgt-header')
    this._content   = this.element.find('.wgt-content')
    this._controls  = this.element.find('.wgt-controls')
    this._input     = this.element.find('.wgt-controls textarea[type="text"]')
    // Init SessionStorage
    this._messagesSessionStorage      = storage('messages', [])
    this._messagesSessionCookie       = sessionCookie('last.messages', [])

    // Events
    this._on(this.element, {
      'show': function (event) {
        this._show(this.element)
        if (!window.matchMedia('(min-width: 600px)').matches) {
          disableBodyScroll(document.querySelector('.wgt-content'))
        }
        // WIP: trigger transfer action when show widget for development
        // this._trigger('transfer', null, [this, {to: 'agent'}])
      },
      'hide': function (event) {
        this._hide(this.element)
        if (!window.matchMedia('(min-width: 600px)').matches) {
          enableBodyScroll(document.querySelector('.wgt-content'))
        }
      },
      'submit .wgt-controls': function (event) {
        event.preventDefault()
        var text = jQuery('<div>').text((this._input.val().trim())).html()
        /* truncate long text before emit the message */
        if (text.length > this.options.constants.MAXLENGTH_INPUT) text = text.substring(0, this.options.constants.MAXLENGTH_INPUT) + '...'
        if (text) {
          this.send({
            type: 'text',
            payload: text
          })
          this._input.val('')
        }
      },
      'click .wgt-header-toolbar button[data-action="close"]': function (event) {
        event.preventDefault()
        this.element.trigger('hide')
      },
      'click .wgt-header-toolbar button[data-action="refresh"]': function (event) {
        event.preventDefault()
        this.refresh()
      },
      'click .wgt-header .wgt-header-info': function (event) {
        event.preventDefault()
        this.element.trigger('hide')
      },
      'keydown textarea[type="text"]': function (event) {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault()
          this._controls.trigger('submit')
        }
      }
    })
  },

  _init: function () {
    this._header.find('button[data-action="refresh"]').hide()
    this.disable()
    this._startSpinner()

    // before of conect the socket reviews if we have conversations saved
    // this._pageViewCountSessionStorage.get().length

    if (cookie.getCookie('to.id') == ''){
      this._messagesSessionStorage.reset()
      this._messagesSessionCookie.delete('last.messages')
    }

    if(this._messagesSessionStorage && this._messagesSessionStorage.get().length){
      if(this._messagesSessionCookie && this._messagesSessionCookie.get().length){
        this._messagesSessionCookie.get().forEach(elem => {
          let isRepetead = this._messagesSessionStorage.get().some(e => e.id === elem.id)
          if (!isRepetead){
            this._messagesSessionStorage.set(elem)
            if (elem.id_option) {
              this._messagesSessionStorage.updateOption(elem)
            }
          }
        })
      }else{
        this._messagesSessionStorage.reset()
      }
      this._messagesSessionStorage.get().forEach(elem => {
        'emit' in elem ? this.send(elem, false) : this._messageEntryRenderActions(this, elem)
      })
    }else{
      if(this._messagesSessionCookie && this._messagesSessionCookie.get().length){ 
        this._messagesSessionCookie.get().forEach(elem => {
          'emit' in elem ? this.send(elem, false) : this._messageEntryRenderActions(this, elem)
          this._messagesSessionStorage.set(elem)
        })
    }
    }
    
    if (this._socket && this._socket.connected) this._socket.close()

    let optSocketIo = {
      transports: ['websocket'],
      query: {
        context: JSON.stringify({
          path: `${window.location.pathname}`,
          origin: this.options.constants.ORIGIN_NAME
        }),
        connect_sid: "",
        to_id: ""
      },
      forceNew: true,
      reconnection: false
    }

    // if there are stored messages in cookies we get cookies (socket and conversation) from browser.
    // otherwise, we delete current widget cookies in browser    
    if(this._messagesSessionCookie && this._messagesSessionCookie.get().length){
      optSocketIo.query.connect_sid = cookie.getCookie('connect.sid') || ""
      optSocketIo.query.to_id       = cookie.getCookie('to.id') || ""
    } else {
      cookie.setCookie('connect.sid', '', 0)
      cookie.setCookie('to.id', '', 0)
    }
    
    this._socket = io(`${this.options.server.protocol}://${this.options.server.host}`, optSocketIo)

    this._socket.on('connect', () => {
      console.log('connected')
      if(!cookie.getCookie('connect.sid')) cookie.setCookie('connect.sid', this._socket.id, 1)
      this.enable()
      //autoscroll if exist storage of messages
      this._scroll('bottom')
      this._stopSpinner()
    })
 
    this._socket.on('message', message => {
      if(!cookie.getCookie('to.id')) cookie.setCookie('to.id', message.to.id, 1)
      message.time = this.getLocalDate()
      //Check messages to validate template change in widget's header
      this.checkTransferMessages(message)
      this._stopSpinner()  
      this._messageEntryRenderActions(this, message)
      if(this._messagesSessionCookie.isEmpty()) this._messagesSessionStorage.reset()
      if(this._messagesSessionStorage != null) this._messagesSessionStorage.set(message)
      if(this._messagesSessionCookie != null) this._messagesSessionCookie.set(message, true)
    })

    this._socket.on('disconnect', () => {
      console.error('disconnected')
    })

  },
  _messageEntryRenderActions: (self, message) => {
    switch (message.type) {
      case 'text':
      if (message.payload.trim()) {
        self._log(util.render('message', {
          sender: 'assistant',
          message: message.payload,
          time: message.time
        }))
      }
      break
      case 'option':
        self._trigger('options', null, 
          [self, {
            options: message.payload.options,
            title: message.payload.title,
            description: message.payload.description,
            time: message.time,
            id_option: message.id
          }])
      break
      case 'image':
        self._trigger('images', null, [self, message.payload])
      break
      case 'carousel':
        self._trigger('carousel', null, [self, message.payload])
      break
      case 'transfer':
        self._trigger('transfer', null, [self, message.payload])
      break
      case 'epa':
        self._trigger('epa', null, [self, message.payload])
      break
      case 'action':
        self._trigger(message.payload.name, null, [self, message.payload.parameters])
      break
      default:
      console.error('message type not supported')
    }
  },

  _destroy: function () {
    this._super()
  },

  _scroll: function (position) {
    switch (position) {
      case 'bottom':
        let lastMessage = this._content.find('.wgt-message').get(-1)
        let scrollTime = 500
        if (lastMessage) scrollTime = Math.round(lastMessage.clientHeight * 4)
        this._content.animate({
          scrollTop: this._content.prop('scrollHeight')
        }, scrollTime)
        break
      case 'top':
        console.error('scroll ' + position + ' not implemented')
        break
      default:
        console.error('invalid scroll value')
    }
  },

  _send: function (message, isTransferFinished) {
    if (this._socket) {
      if (this._messagesSessionCookie.isEmpty()) {
        cookie.setCookie('connect.sid', '', 0)
        cookie.setCookie('to.id', '', 0)
        this.clear()
        this._init()
      }else{
      message.emit = 'user'
      message.time = this.getLocalDate()
        message.id = uuidV4()
      isTransferFinished = isTransferFinished || false
      // save in sessionStorage its mesagge
      if(this._messagesSessionStorage && !isTransferFinished) {      
        this._messagesSessionStorage.set(message)
          this._messagesSessionCookie.set(message)
        //Update option in session storage to remember which button was clicked 
          if (message.id_option) {
            this._messagesSessionStorage.updateOption(message)
            if(this._messagesSessionCookie != null){
              this._messagesSessionCookie.updateOption(message)
            } 
          }
      }
      this._socket.emit('message', message)
    }    
    }    
  },

  _log: function (content) {
    this._content.append(content)
    this._scroll('bottom')
  },

  _startSpinner: function () {
    if (!this._spinner) {
      this._spinner = jQuery(util.render('spinner'))
    }
    this._log(this._spinner)
  },

  _stopSpinner: function () {
    if (this._spinner) {
      this._spinner.remove()
    }
  },

  // Public methods
  disable: function () {
    this._input.prop('disabled', true)
  },

  enable: function () {
    this._input.prop('disabled', false)
    this._input.focus()
  },

  clear: function () {
    this._content.empty()
  },

  refresh: function () {
    // this.clear()
    // this._init()
    //this._send({
    //  type: 'text',
    //  payload: 'retomar_conversacion'
    //})
  },

  getLocalDate: function () {
    let d = new Date()
    let localTimeString = d.toLocaleTimeString().split(':')
    let localDate = `${localTimeString[0]}:${localTimeString[1]}`
    return localDate
  },
  send: function (message, socketEmit) {
    socketEmit = typeof(socketEmit) != 'undefined' ? socketEmit : true
    switch (message.type) {
      case 'text':
        let localDate = this.getLocalDate()
        //Show label of button options if comes
        this._log(util.render('message', {
          sender: 'user',
          message: message.labelButton || message.payload,
          time: !socketEmit ? message.time : localDate
        }))
        break
      default:
        console.error('message type not supported')
    } 
    let sender
    if (message.from) sender = message.from.role || ''
    //sender !== 'agent'
    //check if the header has a class agent 
    if (!this.isAgentTransfer()) this._startSpinner()
    if (socketEmit) this._send(message)
  },
  isAgentTransfer: function(){
    return this._header.hasClass('agent')
  },
  checkTransferMessages: function (message) {
    if ( message.type === 'transfer' ){
      this._messagesSessionStorage.deleteLastItemType("transfer")
    }

    let isChangeHeaderToClaudia = (message.from.role.toUpperCase() == 'assistant'.toUpperCase() && this.isAgentTransfer())
    let isChangeHeaderToAgent = (message.from.role.toUpperCase() == 'user'.toUpperCase() && !this.isAgentTransfer())

    let isNecessaryChangeHeader = ( isChangeHeaderToClaudia || isChangeHeaderToAgent)
    let messageTransfer
    if (isNecessaryChangeHeader) {
      messageTransfer = JSON.parse(JSON.stringify(message))
      messageTransfer.id = uuidV4()
      messageTransfer.type = "transfer"

      if ( isChangeHeaderToClaudia ) {
        messageTransfer.payload = {
          to : "claudia-reset"  
        }
        this._trigger('transfer', null, [this, {to:"claudia-reset"}])          
      }

      if ( isChangeHeaderToAgent ) {
        messageTransfer.payload = {
          to : "agent"  
        }
        this._trigger('transfer', null, [this, {to:"agent"}])        
      }

      if(this._messagesSessionStorage != null) {
        this._messagesSessionStorage.deleteLastItemType("transfer")
        this._messagesSessionStorage.set(messageTransfer)  
      }  
    }    
  }
})

jQuery.widget('vaf.chatwidgetswitch', {
  _create: function () { 
    this._wgt = null
    // beahaviour for mobiles
    if (browser.isMobile()) {
      this.element.html(util.render('switch-whatsapp', {
        iconWhatsapp: assets.images.wgt.iconWhatsapp
      }))
      
      this.element.on('click', event => { 
        window.open(`${global.gConfig.numero_whatsapp}`, "_blank")     
      })      
    }else{ 
      // beahaviour for desktops
      this.element.html(util.render('switch', {
        icon: assets.images.wgt.icon
      }))

      this.element.one('click', event => { 
        this._wgt = jQuery('<aside>').chatwidget()
        jQuery('body').append(this._wgt)            
      })
    }
    
    this._on(this.element, {
      'click': function (event) {
        if (!browser.isMobile()) {
          event.preventDefault()
          this._wgt.trigger(this._wgt.is(':visible') ? 'hide' : 'show')
        }        
      }
    })
  }
})
